import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";
import { filter, find, map, size, truncate } from "lodash";

import SkeletonListItem from "../SkeletonListItem";
import { aprovarOrdensDeCompra, getOrdensDeCompra } from "./action";
import * as S from "./styles";
import Button from "../Button-v2";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Collapse,
  Checkbox,
  Grid,
  Card,
} from "@mui/material";
import { Box } from "@mui/system";
import { formatDate, getDateFns, parseTimestamp } from "../../utils/dateFns";
import { formatMonetary } from "../../utils/formats";
import { sub } from "date-fns";
import BorderedDatePicker from "../DatePicker";

export const OrdemCompraList = () => {
  const [dataInicio, setDataInicio] = useState(sub(getDateFns(), { days: 30 }));
  const [dataFim, setDataFim] = useState(getDateFns());

  const [isLoading, setIsLoading] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);
  const [ordensDeCompra, setOrdensDeCompra] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    loadData();
  }, [dataInicio, dataFim]);

  const loadData = () => {
    if (!isLoading) {
      setIsLoading(true);
      setOrdensDeCompra([]);

      getOrdensDeCompra({ dataInicio, dataFim })
        .then((response) => {
          const {
            data: { data },
          } = response;
          setOrdensDeCompra(data);
        })
        .catch(() => {
          toast.error("Erro ao buscar as ordens de compra.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleSelect =
    (row) =>
    ({ target: { checked } }) => {
      if (checked) {
        setSelectedRows([...selectedRows, row]);
      } else {
        setSelectedRows(filter(selectedRows, (it) => it !== row));
      }
    };

  const handleApprove = () => {
    setApproveLoading(true);
    aprovarOrdensDeCompra(selectedRows)
      .then(() => {
        toast.success("Ordens de compra aprovadas com sucesso!");
        setSelectedRows([]);
        loadData();
      })
      .catch((e) => {
        toast.error("Erro ao aprovar ordens de compra");
      })
      .finally(() => {
        setApproveLoading(false);
      });
  };

  function Row(props) {
    const { row } = props;
    const {
      codEmpresa,
      nomeEmpresa,
      codOrdemCompra,
      codPessoaFornecedor,
      nomePessoaFornecedor,
      aprovado,
      dataEmissao,
      dataImpressao,
      valorTotal,
      usuarioCadastramento,
      status,
    } = row;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow>
          <TableCell>
            <S.TableCellContent>
              <Checkbox
                onClick={handleSelect(row)}
                checked={find(selectedRows, (it) => it === row) !== undefined}
              ></Checkbox>
            </S.TableCellContent>
          </TableCell>
          <TableCell onClick={() => setOpen(!open)} component="th" scope="row">
            <S.TableCellContent>{codOrdemCompra}</S.TableCellContent>
          </TableCell>
          <TableCell onClick={() => setOpen(!open)}>
            <S.TableCellContent>
              {formatDate(parseTimestamp(dataEmissao))}
            </S.TableCellContent>
          </TableCell>
          <TableCell onClick={() => setOpen(!open)}>
            <S.TableCellContent>{usuarioCadastramento}</S.TableCellContent>
          </TableCell>
          <TableCell onClick={() => setOpen(!open)}>
            <S.TableCellContent>
              {truncate(nomePessoaFornecedor, { length: 24 })}
            </S.TableCellContent>
          </TableCell>
          <TableCell onClick={() => setOpen(!open)}>
            <S.TableCellContent>
              {formatMonetary(valorTotal)}
            </S.TableCellContent>
          </TableCell>
          <TableCell onClick={() => setOpen(!open)}>
            <S.TableCellContent>
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </S.TableCellContent>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Grid container spacing={1}>
                  <Grid item xs={8}>
                    <S.DetailsWrapper>
                      <S.DetailTitle>Empresa</S.DetailTitle>
                      <S.DetailContent>{`${codEmpresa} - ${nomeEmpresa}`}</S.DetailContent>
                    </S.DetailsWrapper>
                  </Grid>
                  <Grid item xs={2}>
                    <S.DetailsWrapper>
                      <S.DetailTitle>Status</S.DetailTitle>
                      <S.DetailContent justify="center">
                        {aprovado === "S" ? "Aprovada" : "Não aprovada"}
                      </S.DetailContent>
                    </S.DetailsWrapper>
                  </Grid>
                  <Grid item xs={2}>
                    <S.DetailsWrapper>
                      <S.DetailTitle>Data Impressão</S.DetailTitle>
                      <S.DetailContent justify="center">
                        {formatDate(parseTimestamp(dataImpressao)) || "-"}
                      </S.DetailContent>
                    </S.DetailsWrapper>
                  </Grid>
                  <Grid item xs={8}>
                    <S.DetailsWrapper>
                      <S.DetailTitle>Fornecedor</S.DetailTitle>
                      <S.DetailContent>{`${codPessoaFornecedor} - ${nomePessoaFornecedor}`}</S.DetailContent>
                    </S.DetailsWrapper>
                  </Grid>
                  <Grid item xs={4}>
                    <S.DetailsWrapper>
                      <S.DetailTitle>Status</S.DetailTitle>
                      <S.DetailContent justify="center">
                        {status || "-"}
                      </S.DetailContent>
                    </S.DetailsWrapper>
                  </Grid>
                </Grid>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <S.FiltersWrapper>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} lg={3}>
            <BorderedDatePicker
              label="Data inicial"
              selected={dataInicio}
              setSelected={(value) => setDataInicio(value)}
            />
          </Grid>
          <Grid item xs={12} sm={4} lg={3}>
            <BorderedDatePicker
              label="Data final"
              selected={dataFim}
              setSelected={(value) => setDataFim(value)}
            />
          </Grid>
        </Grid>
      </S.FiltersWrapper>
      {isLoading ? (
        <>
          <SkeletonListItem />
          <SkeletonListItem />
          <SkeletonListItem />
        </>
      ) : size(ordensDeCompra) > 0 ? (
        <S.CardWrapper>
          <Card>
            <S.TableWrapper>
              <Table size="small" aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell>Selecionar</TableCell>
                    <TableCell>Ordem de Compra</TableCell>
                    <TableCell>Data</TableCell>
                    <TableCell>Usuário</TableCell>
                    <TableCell>Fornecedor</TableCell>
                    <TableCell>Valor</TableCell>
                    <TableCell>Expandir</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {map(ordensDeCompra, (row) => (
                    <Row
                      key={`${row.codEmpresa}-${row.codOrdemCompra}`}
                      row={row}
                    />
                  ))}
                </TableBody>
              </Table>
            </S.TableWrapper>
          </Card>
        </S.CardWrapper>
      ) : (
        <S.NoDataMessageWrapper>
          Não há ordens de compra pendentes de aprovação
        </S.NoDataMessageWrapper>
      )}
      <S.ButtonWrapper>
        <Button
          onClick={handleApprove}
          disabled={size(selectedRows) === 0}
          loading={approveLoading}
          height="48px"
          width="150px"
        >
          Aprovar selecionados
        </Button>
      </S.ButtonWrapper>
    </>
  );
};

export default OrdemCompraList;
